// extracted by mini-css-extract-plugin
export default {"address":"home_2_address__u+XmE"};